@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading) {
  <div class="sideBarContent editModelDetailComponent content">
    <irb-editor-sidebar-banner
      [accordian]="accordian"
      [showUnsavedChangesWarning]="showUnsavedChangesWarning"
      [isModified]="isModified"
      [isValid]="isValid"
      [hasPendingFunction]="hasPendingFunction"
      [slot]="slot"
      (save)="save()"
      (cancel)="cancel()">
      <span header class="ms-header" tooltip [tooltipTitle]="slideOutTitle" [tooltipRequiresTruncation]="true">
        {{slideOutTitle}}
      </span>
      <span buttonsInFront>
        @if (!showUnsavedChangesWarning) {
          <button class="btn-medium-primary" id="editorSideReBalanceButton" (click)="onCreateRebalance()"
            [disabled]="isModified || !isRebalanceBtnEnabled ? true : false"
          >Rebalance</button>
        }
      </span>
      <span buttonsInEnd>
        @if (modelEventData.showCopyModel && isCopyModelEnabled && !showUnsavedChangesWarning) {
          <button class="btn-medium-secondary" style="position: relative"
            (click)="onCopyModel()"
            [disabled]="isModified || !isValid"
            >Create a copy
          </button>
        }
        <button style="position: relative;" [matMenuTriggerFor]="subMenuSAC" class="btn-medium-secondary btnWithArrow"
          >Go to SAC<i class="material-icons md-24 md-align dropdown-arrow-align" >arrow_drop_down</i>
          <mat-menu #subMenuSAC="matMenu" class="nav__items_action_btn" yPosition="below">
            <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=R_MARK','_blank')">Research</button>
          </mat-menu>
        </button>
      </span>
    </irb-editor-sidebar-banner>
    <div [style.height]="bodyHeight" #body class="irb-editors-edit-model body">
      @if (eventPrevNextObject && modelEventData && modelEventData.showNextPrev) {
        <editor-model-prevnext [eventPrevNextObject]="eventPrevNextObject"></editor-model-prevnext>
      }
      @if ((isSubscribeModel && autoRebalPaused && bmas?.globalSettings?.isAutoRebalanceEnabled && isMMCAutomationEnabledFlag)) {
        <div class="block  status-pending-review-warning">
          <div class="left" style="width: calc(100% - 50px);">
            <p class="message">
              <span>
                Automated rebalancing has been paused because one or more component models were changed by the model provider. You can review the changes in the model’s Model History and resume automated rebalancing, leave it paused, or replace the component model.
              </span>
            </p>
          </div>
          <div class="clear"></div>
        </div>
      }
      <div class="block editorDisplayBanner editor-subscribe-model-banner" style="padding-bottom:0px;">
        <div class="subscribe-model-banner-item model-name-width" style="min-width:245px;">
          <div class="subscribe-model-banner-title">Model Name
          </div>
          @if (!showInLineeditFlag) {
            <div
              class="subscribe-model-banner-value">{{ data.blendedSecurityModelName }}
              <a class="editModelDetailEditLink" id="editLinkModelName2"(click)="showInlineEdit()">
                <img src="../../../assets/images/edit.png" alt="Edit" style="height:14px;vertical-align:top;">
              </a>
            </div>
          }
          @if (showInLineeditFlag) {
            <irb-com-inlineedit [(tooltipMessage)]="tooltipMessage"
              defaultTooltip="Please provide valid model name."
              [(data)]="data.blendedSecurityModelName"
              allowSpecialCharacters="true"
              (save)="saveInlineEdit($event)" (close)="closeInlineEdit()"
              maxlength="100"
            (change)="onTextChange()"></irb-com-inlineedit>
          }
        </div>
        <div class="subscribe-model-banner-item model-description-width" style="min-width:245px;">
          <div class="subscribe-model-banner-title">Model Description
          </div>
          @if (!showInLineEditDescFlag) {
            <div
              class="subscribe-model-banner-value">{{ data.blendedSecurityModelDescription }}
              <a class="editModelDetailEditLink" id="editLinkDescr2" (click)="showInlineDescEdit()">
                <img src="../../../assets/images/edit.png" alt="Edit" style="height:14px;vertical-align:top;">
              </a>
            </div>
          }
          @if (showInLineEditDescFlag) {
            <irb-com-inlineedit [(tooltipMessage)]="tooltipDescMessage"
              defaultTooltip="Please provide valid model description."
              [(data)]="data.blendedSecurityModelDescription"
              allowSpecialCharacters="true"
              (save)="saveInlineDescEdit($event)" (close)="closeInlineDescEdit()"
            maxlength="100"></irb-com-inlineedit>
          }
        </div>
        <div class="subscribe-model-banner-item">
          <div class="subscribe-model-banner-title">Type</div>
          <div class="subscribe-model-banner-value">Blended</div>
        </div>
        <div class="subscribe-model-banner-item">
          <div class="subscribe-model-banner-title">Models</div>
          <div class="subscribe-model-banner-value">{{noOfModels}}</div>
        </div>
        <div class="subscribe-model-banner-item">
          <div class="subscribe-model-banner-title">Securities</div>
          <div class="subscribe-model-banner-value">{{ data.noOfSecurities }}</div>
        </div>
        @if (!(pfCount===undefined)) {
          <div class="subscribe-model-banner-item" >
            <div class="subscribe-model-banner-title" style="padding-bottom:8px;">Portfolios</div>
            <a class="subscribe-model-banner-value" tooltip [tooltipTitle]="isModified ? 'The model has unsaved changes. You\'ll need to save the changes before navigating to the portfolios.': null"
              tooltipPosition="bottom"
            (click)="showPortfoliosByModel()">{{ pfCount || 0 }} {{(pfCount === 1) ? 'portfolio' : 'portfolios'}}</a>
          </div>
        }
        <div class="subscribe-model-banner-item">
          <div class="subscribe-model-banner-title">Vendor Shared</div>
          <div class="subscribe-model-banner-value">
            <p-checkbox name="isVendorShared" [(ngModel)]="data.isVendorShared"
            [disabled]="data.isAPIEnabled" binary="true" (onChange)="onInputChange();"></p-checkbox>
          </div>
        </div>
        @if (isSubscribeModel && bmas?.globalSettings?.isAutoRebalanceEnabled && isMMCAutomationEnabledFlag) {
          <div class="subscribe-model-banner-item medium-second-line-width">
            <div class="subscribe-model-banner-title">Allow Automated Rebalances</div>
            <div class="mat-slide-toggle-container">
              <mat-slide-toggle [checked]="autoRebalAllowed"
                [disabled]="true">
              </mat-slide-toggle>
            </div>
          </div>
        }
      </div>
      <mat-accordion #accordian="matAccordion" [multi]="true">
        <mat-expansion-panel id="BLENDEDMODELHISTORY" [expanded]="blendedAllocationHistoryState"
          (opened)="onOpenHistoryPanel();"
          (closed)="onCloseHistoryPanel()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Model History
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            @if (historyData) {
              <irb-security-model-history [data]="historyData"
                [createModifyData]="createModifyData"
              modelType="Blended" ></irb-security-model-history>
            }
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel id="MODALALLOCATIONS" [expanded]="blendedModalAllocationState"
          (opened)="ies.updateExpansionState('MODALALLOCATIONS','opened');this.allocationPanelOpened = true"
          (closed)="ies.updateExpansionState('MODALALLOCATIONS','closed');this.allocationPanelOpened = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Model Allocations @if ((autoRebalPaused || autoRebalNotAllowed) && isSubscribeModel && !allocationPanelOpened  && bmas?.globalSettings?.isAutoRebalanceEnabled && isMMCAutomationEnabledFlag) {
              <img
                class="quick-icons" src="../../../assets/images/warning-icon-amber.svg" style="margin-bottom: 3px; margin-left:10px">
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            @if ((autoRebalPaused) && isSubscribeModel && bmas?.globalSettings?.isAutoRebalanceEnabled && isMMCAutomationEnabledFlag) {
              <div class="block  status-pending-review-warning">
                <p class="message">
                  <span>
                    One or more component models have been changed by the model provider. Select the model’s name to review its Model History and resume automated rebalancing.
                  </span>
                </p>
                <ul class="dotted-list">
                  @for (item of autoRebalPausedList; track item) {
                    <li style="list-style-type: disc; margin-left: 20px;">
                      <a href="#" (click)="openSecurityModel(item); $event.preventDefault();">{{ item.securityModelName }}</a>
                    </li>
                  }
                </ul>
              </div>
            }
            @if ((autoRebalNotAllowed) && isSubscribeModel && bmas?.globalSettings?.isAutoRebalanceEnabled && isMMCAutomationEnabledFlag) {
              <div class="block  status-not-allowed">
                <p class="message">
                  <span>
                    One or more component models does not allow automated rebalancing. To use automated rebalancing for blended models, all component models must be set to allow it.
                  </span>
                </p>
                <ul class="dotted-list">
                  @for (item of autoRebalNotAllowedList; track item) {
                    <li style="list-style-type: disc; margin-left: 20px;">
                      <a href="#" (click)="openSecurityModel(item); $event.preventDefault();">{{ item.securityModelName }}</a>
                    </li>
                  }
                </ul>
              </div>
            }
            @if (data) {
              <irb-blended-models-allocation [(data)]="data" [mmcModelIds]="mmcModelIds"
              (change)="onInputChange()"></irb-blended-models-allocation>
            }
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel id="BLSECURITYALLOCATIONS" [expanded]="blendedSecAllocationState"
          (opened)="ies.updateExpansionState('BLSECURITYALLOCATIONS','opened')"
          (closed)="ies.updateExpansionState('BLSECURITYALLOCATIONS','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Security Allocations
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          @if (data) {
            <irb-blended-security-allocation [data]="data"></irb-blended-security-allocation>
          }
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel id="BLSECURITYALLOCATIONSCHART" [expanded]="blendedSecurityAllocationChartState"
        (opened)="ies.updateExpansionState('BLSECURITYALLOCATIONSCHART','opened')"
        (closed)="ies.updateExpansionState('BLSECURITYALLOCATIONSCHART','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Allocations Chart
            @if (ENABLE_SEC_GRID_CHART) {
              <span style="margin-left: auto">
                <button class="btn-slim-primary settings-right" style="margin-right: 10px;" (click)="$event.stopPropagation(); showAllocationCustomView = true;" [disabled]="showAllocationCustomView">Customize view</button>
              </span>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          @if (ENABLE_SEC_GRID_CHART) {
            @if (data && !isUiTest) {
              <irb-security-allocations-chart modelType="Blended"
              [(showCustomView)]="showAllocationCustomView"></irb-security-allocations-chart>
            }
          } @else {
            @if (data) {
              <irb-legacy-allocations-chart
              modelType="Blended"></irb-legacy-allocations-chart>
            }
          }
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
}
